require('./index.dev.js')